<template>
  <b-row class="mb-4 align-items-end">
    <b-col sm="12" md="9">
      <span v-html="kriterium.name[$i18n.locale]"></span>

      <b-form-group v-show="kriterium.typ === 'radio'">
        <b-form-radio-group v-model="kriterium.value" :state="getState">
          <b-form-radio
            v-for="option in kriterium.options"
            :value="option.value"
            :name="'kriteriumID' + kriterium.id"
            :disabled="disabled"
            v-bind:key="option.value"
            :state="getState"
            >{{ option[$i18n.locale] }}</b-form-radio
          ></b-form-radio-group
        >
      </b-form-group>

      <span v-if="kriterium.typ === 'number'">
        <b-form-group :invalid-feedback="getMsg" :state="getState">
          <b-form-input
            :id="'kriteriumID' + kriterium.id"
            :name="'kriterium' + kriterium.id"
            v-model.number="kriterium.value"
            type="number"
            :disabled="disabled"
            required="required"
            :placeholder="getPlaceholder"
            :state="getState"
            v-on:blur="toDecimal"
            :step="getStep"
          ></b-form-input>
        </b-form-group>
      </span>

      <b-form-group v-show="kriterium.typ === 'select'">
        <b-form-select
          v-model="kriterium.value"
          :id="'kriteriumID' + kriterium.id"
          :name="'kriteriumID' + kriterium.id"
          :state="getState"
          required="required"
        >
          <template v-slot:first>
            <b-form-select-option :value="null">{{
              $t("BitteWaehlen")
            }}</b-form-select-option>
          </template>
          <b-form-select-option
            :value="option.value"
            :disabled="option.disabled"
            v-for="option in kriterium.options"
            v-bind:key="option.value"
            >{{ option[$i18n.locale] }}</b-form-select-option
          >
        </b-form-select>
      </b-form-group>
    </b-col>
    <b-col sm="12" md="3" light>
      <b-button
        v-if="kriterium.text[$i18n.locale].length > 0"
        v-b-toggle="'collapse' + kriterium.id"
        class="btn-sm mt-1 mt-md-0"
        variant="outline-info"
      >
        <span class="glyphicons glyphicons-question-sign"></span>
        {{ $t("Erlaeuterungen") }}
      </b-button>
      <!--  wohl doch lieber per html ? 
      <div v-if="typeof kriterium.image != 'undefined' && kriterium.image.length > 0">XXXXXXX<img :src="kriterium.image" width="100%"></div>
     -->
    </b-col>
    <b-col sm="12">
      <b-collapse :id="'collapse' + kriterium.id">
        <b-card v-html="kriterium.text[$i18n.locale]"></b-card>
        <br />
      </b-collapse>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "SelbstdeklarationZeile",
  props: {
    disabled: { type: Boolean, default: false },
    paketID: Number,
    kriteriumID: Number,
    state: {
      type: Function,
      default: function() {
        return null;
      },
    }, // https://bootstrap-vue.js.org/docs/components/form-input/#contextual-states
    kriterium: { type: Object },
  },

  computed: {
    getState() {
      return this.state(this.kriterium);
    },
    getMsg() {
      return typeof this.kriterium.errorMsg == "undefined"
        ? ""
        : this.kriterium.errorMsg[this.$i18n.locale];
    },
    getStep() {
      return "0.01";
    },
    getPlaceholder() {
      return "0.00";
    },
  },
  methods: {
    toDecimal() {
      this.kriterium.value = this.kriterium.value
        ? this.financial(this.kriterium.value)
        : this.kriterium.value;
    },
    financial(x) {
      return Number.parseFloat(x).toFixed(2);
    },
  },
  watch: {
    'kriterium.value': function() {
      console.log('kriterium value changed'+this.kriterium.key)
      if (typeof this.kriterium.onChange == "function") {
        this.kriterium.onChange();
      }
    },
  },
};
</script>
<style scoped>
.form-group {
  margin-bottom: 0;
}
</style>
